import { NgModule } from '@angular/core';
import { DopAnalysisComponent } from './features/dop-analysis/dop-analysis.component';
import { TreeTableModule } from 'primeng/treetable';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { TreeModule } from 'primeng/tree';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { TreeClearInputDirective } from './directives/clear-input.directive';
import { AnalysesToolTipComponent } from './features/analysis-tool-tip/analyses-tool-tip.component';
import { ScrollListenerDirective } from './directives/scroll-listener.directive';
import { QuotationDetailsComponent } from './features/quotation-details/quotation-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdvanceSearchComponent } from './features/advance-search/advance-search.component';
import { HighlightTextPipe } from './pipes/highlight-text.pipe';
import { AutoResizeDirective } from './directives/textarea-autoresize.directive';
import { DopTableModule } from 'projects/dop-table/src/public_api';
import { AccordionModule } from 'primeng/accordion';
import { InputNumberDirective } from './directives/input-number.directive';
import { DopCoreModule } from 'projects/dop-core/src/public-api';

@NgModule({
  declarations: [
    DopAnalysisComponent,
    TreeClearInputDirective,
    AnalysesToolTipComponent,
    ScrollListenerDirective,
    AutoResizeDirective,
    QuotationDetailsComponent,
    AdvanceSearchComponent,
    HighlightTextPipe,
    InputNumberDirective
  ],
  imports: [
    TreeTableModule,
    CommonModule,
    OverlayPanelModule,
    ProgressSpinnerModule,
    ButtonModule,
    InputSwitchModule,
    ReactiveFormsModule,
    TabViewModule,
    TreeModule,
    InputTextModule,
    InputTextareaModule,
    CheckboxModule,
    FormsModule,
    DopTableModule,
    AccordionModule,
    TableModule,
    DopCoreModule,
    TooltipModule
  ],
  exports: [
    DopAnalysisComponent,
    QuotationDetailsComponent,
    ScrollListenerDirective,
    AnalysesToolTipComponent
  ]
})
export class DopOrderingModule { }
